import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Strong } from '@nebula/global-styles';
import nebulaTheme from '@nebula/theme';

import FraudDetectionImg from './FraudDetectionImg';
import {
  Container,
  ImageContainer,
  ContentContainer,
  StyledTitleLarge700,
  StyledHelperText,
  StyledHelperTextContent,
} from './index.style';

export default function IDDownSell() {
  return (
    <ThemeProvider theme={nebulaTheme}>
      <Container>
        <ImageContainer>
          <FraudDetectionImg />
        </ImageContainer>
        <ContentContainer>
          <StyledTitleLarge700>You&apos;ll lose fraud protection if you cancel</StyledTitleLarge700>
          <StyledHelperText>
            <Strong>One in four people have been a victim of fraud</Strong>
          </StyledHelperText>
          <StyledHelperTextContent>
            Your email address and passwords will no longer be monitored to check if they&apos;re exposed on the dark
            web.
          </StyledHelperTextContent>
          <StyledHelperTextContent>
            Without <Strong>Identity Plus</Strong> you&apos;ll no longer get real-time alerts that help you detect and
            prevent fraud.
          </StyledHelperTextContent>
        </ContentContainer>
      </Container>
    </ThemeProvider>
  );
}
